import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Performance monitoring
const startTime = performance.now();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Log performance metrics
if (process.env.NODE_ENV === 'development') {
  const endTime = performance.now();
  console.log(`CRONOS React App rendered in ${endTime - startTime}ms`);
  
  // Report vitals in development
  import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
    getCLS(console.log);
    getFID(console.log);
    getFCP(console.log);
    getLCP(console.log);
    getTTFB(console.log);
  });
}